import type { TypeChildren, TypeClassName } from '@/components/types';

export const enum Positions {
  top = 'top',
  bottom = 'bottom',
  topBottom = 'top bottom',
}

export interface TypeWithPaperBorderProps extends TypeClassName, TypeChildren {
  /**
   * ¿Quieres activar el borde superior?
   */
  top?: boolean;
  /**
   * ¿Quieres activar el borde inferior?
   */
  bottom?: boolean;
  /**
   * ¿Quieres que el borde sea interior o exterior?
   */
  border?: 'inside' | 'outside';
  /**
   * ¿Que altura quieres para el border en px?
   */
  borderHeight?: number;
  /**
   * ¿Que color quieres para el border?
   * Debe ser un valor valido para la propiedad CSS
   * `border-color`
   */
  borderColor?: string;
  id?: string;
}
